import { Component, OnInit, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DataService } from 'src/shared/data/data.service';

@Component({
    selector: 'app-testimonials',
    templateUrl: './testimonials.component.html',
    styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit, OnDestroy {
  data: any;
websiteTestimonials: any[] = [];
openTestimonialForm: boolean = false;


testimonialData = {
  name: '',
  message: ''
};
    constructor(private http: HttpClient,private data_service : DataService) { }

    ngOnInit(): void {
      this.startAutoScroll();
      this.loadWebsiteTestimonials(); 
    }

    ngOnDestroy(): void {
      this.clearAutoScroll();
    }

loadWebsiteTestimonials() {
  this.http.get<any[]>(this.data_service.base_url+'get_web_testimonials/')
    .subscribe((res:any) => {
      this.websiteTestimonials = res.testimonials;
      console.log("website testimonials", this.websiteTestimonials)
    });
}
 
 getReviews() {
  const payload = this.data;
    return  this.http.post(this.data.base_url + 'get_google_reviews/',payload).subscribe.apply({
 
    });
  }
    // Google Reviews logic (prefixed with google)
    googleReviews = [
	{
      name:"Lakshmi Priya",
      image:'https://lh3.googleusercontent.com/p/AF1QipPB5QoQeyFQUVHsXjcKbp84Yeufc8km3NPCqXcV=w408-h306-k-no',
      rating:5,
     text: 'One of the best fire protection companies in Doha. Excellent service, high-quality fire safety systems, and a professional team. Highly recommended for reliable and cost-effective solutions.',
      dateAgo:'6 days ago',
      reviewUrl:"https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2xOc1FrRm1iM2xvTnpsc1psRjJlV2huYVRKdk1GRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOlNsQkFmb3loNzlsZlF2eWhnaTJvMFE%7C0cSDuijPzPn%7C?hl=en"
    },
    {
     name:"monish raj",
      image:'https://lh3.googleusercontent.com/a- ALV-UjXAMHb_oq-9GQd_-cYvs8tCDqvLAD3JfDdYvHXLpnxvKop_yXg=s1920-c-rp-mo-ba2-br100',
      rating:5,
     text: "If you're looking for a reliable fire protection company in Doha, this is the right choice. They provide complete fire safety solutions covering all requirements under one roof. What really stands out is their professionalism and customer support. The team takes time to understand your needs, explain the systems clearly, and suggest the best solutions. It’s rare to find this level of service and technical expertise. I have worked with multiple companies before, but Union Fire Protection made the entire process smooth and hassle-free. This is a genuine review based on my experience. Highly recommended for anyone looking for quality and dependable fire safety solutions.",  dateAgo:'a week ago',
      reviewUrl:"https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT2t4blVteFpjWEpKVldWV1VVcE5TMDFITFUxM2JtYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOkxnUmxZcXJJVWVWUUpNS01HLU13bmc%7C0cQvnhTPqvf%7C?hl=en"
    },
 
      {
        name: 'Frank NM',
        image: 'https://lh3.googleusercontent.com/a-/ALV-UjVNNJV8A5mQzTEPG1CGuk7eKaMGFVXUWkzISgplsLwtSDVhWdcRtg=s1920-c-rp-mo-ba4-br100',
        rating: 5,
      text: `Hi, I am writing this review based on my complete satisfaction with Union Fire Protection. When I started my project, fire safety was one of my top priorities, and I was looking for a reliable company to handle it properly. After checking multiple providers, I came across Union Fire Protection.

From the moment I connected with their team, I was impressed by their professionalism and technical knowledge. They clearly explained all fire protection systems and helped me choose the right solutions for my requirements.

Their team was very supportive throughout the entire process, from design to installation and final commissioning. They were patient, responsive, and always ready to clarify any doubts. The quality of work and attention to detail were excellent.

Pricing was reasonable for the quality and service they provided. Overall, the experience was smooth and hassle-free.

I would definitely recommend Union Fire Protection to anyone looking for reliable and professional fire safety solutions. Keep up the great work and thank you for the excellent service.`,  dateAgo: 'a week ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT20xc1JtcDZXamhUYlVSbGVubGZibXh3WmpOd01tYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOm1sRmp6WjhTbURlenlfbmxwZjNwMmc%7C0cLufjDCfZd%7C?hl=en',
        reviewImageUrls: [
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90DPrOHJYgwNVkSjdOQhaX22RpTTMQmrRkp0TCOffTNxrvF19SePOfRNri_qWPmSsX_4ROkujriexGe1R5sZ3l4QecMUhapqnxGvB2gz25zdxhfCQrNQF5zrKx9CBr4qNYKq6XkLRH-Z3dzS",
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90D3onj1BSBN5vFk4YWZaJFyj80XDJQFKEV1TPnU1KQt8v_1xjOdzae1l8QaU7h8gQtaHj1inF6dF2n5K3FDSCtjsDqOchr2jZHN9erntJybxxfGz6fGABL1D82z5l1P3Jj4HCtr3iAn59s",
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90BNFMfdXnOFSk4z1Wj6hN4FKT1rcK0tUuzdKn4QleEww_GWUNTDXxAs7_YliWpDscd-_5QYHj3u3Sf9icU5GAgzM0ugiF56ShpT6wdrpQikhL3dkB8GqcTWqYizT8SrOlDFO3BgyiGlsXw",
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90A4h7pubNz6y3GDOt2nPV7nBryvbADRe-UVwRW9rQ4QgQYPP6meFxi4w_HigGMnLMeg8fylPQHHGE2c35pTzOl6q4qY6qHnX2SDI8Ju9uLEs2dXiy_pwPHlXN0i7f0TjO_dAMwnpMi0Yp4X",
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90CzZiAahuc1sTqvi0Dv1r6DPFeCb81wQBPMsmZaBkCF2eJOeYCNss9VHwjehCtbOAU6xjfPzPsNfPvSkXO68HMD3oSMg4dy4WB4zK32CSoPdkDKJPjwCPJn4mbrPQbF-YAv1_tazvau4V-i"
        ]
      },
      {
        name: 'Box Black Internationals',
        image: 'https://lh3.googleusercontent.com/a/ACg8ocLPa5ujQkmZ39yGwSK2ROH1YHPc-wpn3gCVk3sC8L38oUJYPA=s1920-c-rp-mo-br100',
        rating: 5,
       text: 'Wide range of fire safety solutions with competitive pricing. Friendly and professional team.',
        dateAgo: '2 weeks ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25acVZrZzBkRkJLU0doMlgwTkZiMW80WlhKQkxYYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOnZqVkg0dFBKSGh2X0NFb1o4ZXJBLXc%7C0cJEXc3w82s%7C?hl=en',
        reviewImageUrls: []
      },
      {
        name: 'Ram kumar',
        image: 'https://lh3.googleusercontent.com/a-/ALV-UjWV1C9mM06b8HnxI6XiQ_sg8kYEfpFj4GZB6hJiPvB78dkt2pk=s1920-c-rp-mo-br100',
        rating: 5,
       text: 'Excellent service and best experience. The team is very responsive and supportive. Great job!',
        dateAgo: '2 weeks ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VMS0ZyWmVzdWRMajBnRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKELKFrZesudLj0gE%7CCgwIupC-wgYQ8OK1pQM%7C?hl=en',
        reviewImageUrls: []
      },
      {
        name: 'Hunter gaming',
        image: 'https://lh3.googleusercontent.com/a/ACg8ocJOeR3j40WvwJTMy3Tv9BGQzhCFLUVV-DL67hojosBBdASSow=s1920-c-rp-mo-br100',
        rating: 5,
       text: 'Excellent service and professional work. Fully satisfied.',
        dateAgo: '2 weeks ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VQaUczWVhDelBMZnJRRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEPiG3YXCzPLfrQE%7CCgwIoJC8wgYQsNyBvgM%7C?hl=en',
        reviewImageUrls: [
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90C9gvjFdk3XNjX_MxW1MHgQx7HiamWgaiA5xy52QaPBNFM7Wa4lpoYriqiU7BG3fsnEhxSYrapokOlJn7Y_bRRCNVnPkvkYqDkpFOwjrEgA8nd4lGLjrnpbTaZs6wLCQCY0-WWr"
        ]
      },
      {
        name: 'akash kumar',
        image: 'https://lh3.googleusercontent.com/a-/ALV-UjWN3AkbTB664dBVl3rgfYRLazu97I4QtAnx9Sd0gQxtqAb9CiWC=s1920-c-rp-mo-br100',
        rating: 5,
       text: 'Excellent service and latest fire safety solutions.',
        dateAgo: '2 weeks ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sCi9DQUlRQUNvZENodHljRjlvT25KQ05WZDZOekl4UzJaZlFYTkpTRTlRV2sxTVJYYxAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CAIQACodChtycF9oOnJCNVd6NzIxS2ZfQXNJSE9QWk1MRXc%7C0cIioT-cco8%7C?hl=en',
        reviewImageUrls: []
      },
      {
        name: 'Thanga Maari Ac',
        image: 'https://lh3.googleusercontent.com/a-/ALV-UjUc_9XK3J0xBVKCYgV6pYdyf6OjOi_eRNXBiXjve0UtcAHKaA0=s1920-c-rp-mo-ba3-br100',
        rating: 5,
        text: 'One of the leading fire protection companies in Doha with a wide range of safety solutions.',
        dateAgo: '2 weeks ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VNclNwY0NYejllaTR3RRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEMrSpcCXz9ei4wE%7CCgwIyrW7wgYQkMqpzgI%7C?hl=en',
        reviewImageUrls: []
      },
      {
        name: 'Ankit Bansal',
        image: 'https://lh3.googleusercontent.com/a-/ALV-UjWdRjpls-s6nes-e-R4BgbBnHpSrUsAOXnP0sT8MJjhmWN7WAR0=s1920-c-rp-mo-br100',
        rating: 5,
       text: 'One-stop solution for all fire safety needs. Professional team, competitive pricing, and excellent service. Highly recommended.',
        dateAgo: '2 weeks ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VNVFpzYmZVN1pmaF9nRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEMTZsbfU7Zfh_gE%7CCgwIja67wgYQiM3Q5gI%7C?hl=en',
        reviewImageUrls: []
      },
      {
        name: 'lingaraj viki',
        image: 'https://lh3.googleusercontent.com/a-/ALV-UjU5P69SZ6IvPOIUCG9VPf1b96Hm-y7ROGlLJFNJAuu0hLIWQuwf=s1920-c-rp-mo-br100',
        rating: 5,
       text: `I recently worked with Union Fire Protection for my project, and I am extremely satisfied with their service. From the beginning, their team was professional, knowledgeable, and very supportive, helping me understand the complete fire safety requirements.

The quality of their systems and work was excellent, and everything was handled with great attention to detail. What stood out the most was their customer service — they guided me through the entire process, from system design to installation and final commissioning, ensuring everything was done smoothly.

Their team also provided valuable advice on maintenance and safety, making the entire experience hassle-free. I highly recommend Union Fire Protection to anyone looking for reliable and high-quality fire safety solutions. I am very happy with the results.`,
 dateAgo: '2 months ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChZDSUhNMG9nS0VJQ0FnTUNZcE5lLVdBEAE!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEICAgMCYpNe-WA%7CCgsI6PrNwAYQkPrbPg%7C?hl=en',
        reviewImageUrls: [
          "https://lh3.googleusercontent.com/geougc-cs/AB3l90CVr78CjWKB_HCTT0LGZkFj7QIlodsIUkJSmDR2QJ_zxTa46jnYu3IdWIffi9wHlqdiMvR5TVwgFGmoudrOHixPrH1042O1aG7cODnxlX2KzQ9rS9e7xNCPV4u_H1muAMRd7IAX3w"
        ]
      },
      {
        name: 'Arun Sathish',
        image: 'https://lh3.googleusercontent.com/a/ACg8ocLWHauY5Vr-J2bsBTdY1Em3XpOpJdN6TSUPgrCwU7VHbfbF4w=s1920-c-rp-mo-br100',
        rating: 5,
       text: 'The management team at Union Fire Protection is highly professional and dedicated. They take time to understand customer requirements and provide the best fire safety solutions. The entire team is humble, knowledgeable, and delivers excellent service. A complete solution provider for all fire protection needs.',
        dateAgo: '3 months ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnTUR3d1lUUTFnRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEICAgMDwwYTQ1gE%7CCgsIlZGPvwYQoN_6aQ%7C?hl=en',
        reviewImageUrls: []
      },
      {
        name: 'Priya Sethupathi',
        image: 'https://lh3.googleusercontent.com/a/ACg8ocJ8eqopGRWSEb6iqYFdGC_5aYB9ZRKLCwem8a69Gr16sgoYFAA=s1920-c-rp-mo-br100',
        rating: 5,
      text: `I recently worked with Union Fire Protection for my project, and I was highly impressed with their expertise and service quality. Their team was professional, knowledgeable, and very supportive throughout the entire process.

The fire safety systems provided were of excellent quality and met all required standards. What stood out the most was their attention to detail and commitment to delivering the right solutions based on my needs.

The team was courteous, patient, and always ready to assist, making the entire experience smooth and hassle-free. I highly recommend Union Fire Protection to anyone looking for reliable, high-quality fire safety solutions and exceptional customer service.`,
  dateAgo: '5 months ago',
        reviewUrl: 'https://www.google.com/maps/reviews/data=!4m8!14m7!1m6!2m5!1sChdDSUhNMG9nS0VJQ0FnSURfeC1pUndnRRAB!2m1!1s0x0:0x3570a5d70783502b!3m1!1s2@1:CIHM0ogKEICAgID_x-iRwgE%7CCgwI0_XevAYQ8LPG7QI%7C?hl=en',
        reviewImageUrls: []
      }
    ];
    googleVisibleCount = 3;
    googleStartIndex = 0;
    googleExpandedReview: any = null;
    googleModalOpen = false;
    googleSelectedReview: any = null;

    autoScrollInterval: any = null;
    isCarouselHovered = false;

    get googleVisibleReviews() {
      return this.googleReviews.slice(this.googleStartIndex, this.googleStartIndex + this.googleVisibleCount);
    }

    get canGoPrev() {
      return this.googleStartIndex > 0;
    }

    get canGoNext() {
      return this.googleStartIndex < this.googleReviews.length - this.googleVisibleCount;
    }

    googlePrevReview() {
      if (this.canGoPrev) {
        this.googleStartIndex--;
      }
    }

    googleNextReview() {
      if (this.canGoNext) {
        this.googleStartIndex++;
      } else {
        // Loop to start
        this.googleStartIndex = 0;
      }
    }

    googleExpandReview(review: any) {
      this.googleExpandedReview = review;
    }

    googleCollapseReview() {
      this.googleExpandedReview = null;
    }

    googleOpenModal(review: any) {
      this.googleSelectedReview = review;
      this.googleModalOpen = true;
    }

    googleCloseModal() {
      this.googleModalOpen = false;
      this.googleSelectedReview = null;
    }

    startAutoScroll() {
      this.clearAutoScroll();
      this.autoScrollInterval = setInterval(() => {
        if (!this.isCarouselHovered) {
          this.googleNextReview();
        }
      }, 4000);
    }

    clearAutoScroll() {
      if (this.autoScrollInterval) {
        clearInterval(this.autoScrollInterval);
        this.autoScrollInterval = null;
      }
    }

    onCarouselMouseEnter() {
      this.isCarouselHovered = true;
    }

    onCarouselMouseLeave() {
      this.isCarouselHovered = false;
    }

    onImageError(review: any) {
      if (!review.imageRetry) {
        // Retry once after a short delay
        review.imageRetry = true;
        const original = review.image;
        review.image = '';
        setTimeout(() => {
          review.image = original + (original.includes('?') ? '&' : '?') + 'retry=' + Date.now();
        }, 200);
      } else {
        review.image = null;
      }
    }

    onReviewImgError(review: any, idx: number) {
      if (!review.failedReviewImages) {
        review.failedReviewImages = [];
      }
      review.failedReviewImages[idx] = true;
    }


//   submitTestimonial() {

//   const user_id = localStorage.getItem('customer_id');

//   if (!user_id) {
//     alert('Please place an order before adding testimonial');
//     return;
//   }
//   if (!this.testimonialData.name || !this.testimonialData.message) {
//     alert('Please fill all fields');
//     return;
//   }

//   this.http.post('http://127.0.0.1:8000/add_testimonial/', { user_id: user_id,
//     message: this.testimonialData.message ,name :this.testimonialData.name})
//     .subscribe((res: any) => {
//     if (res.status_code === 1) {
//       alert('Thank you for your feedback!');
//       this.openTestimonialForm = false;
//       this.testimonialData.message = '';
//       this.loadWebsiteTestimonials();
//     } else {
//       alert(res.error);
//     }
//   });
// }


submitTestimonial() {
  const orderPlaced = localStorage.getItem('order_placed');
  const customerId = localStorage.getItem('customer_id');

  if (orderPlaced !== 'true' || !customerId) {
    alert('Please place an order before adding a testimonial');
    this.testimonialData.name='';
    this.testimonialData.message='';
    return;
  }

  if (!this.testimonialData.name || !this.testimonialData.message) {
    alert('Please fill all fields');
    return;
  }

  this.http.post(this.data_service.base_url+'add_testimonial/', {
    user_id: customerId,
    name: this.testimonialData.name,
    message: this.testimonialData.message
  })
  .subscribe((res: any) => {
    if (res.status_code === 1) {
      alert('Thank you for your feedback!');
      this.openTestimonialForm = false;
      this.testimonialData.message = '';
      this.loadWebsiteTestimonials();
    } else {
      alert(res.error);
    }
  });
}


}
